import type { ConsentCategory } from './types.js'

export interface CategoryDefinition {
  required: boolean
  description: string
}

export const DEFAULT_CATEGORIES: Record<ConsentCategory, CategoryDefinition> = {
  necessary: { required: true, description: 'Essential cookies for the site to function' },
  analytics: { required: false, description: 'Help us understand how visitors use our site' },
  marketing: { required: false, description: 'Used to deliver relevant advertisements' },
  preferences: { required: false, description: 'Remember your settings and preferences' },
}

/**
 * Returns the list of all category IDs from the default definitions.
 */
export function getAllCategories(): ConsentCategory[] {
  return Object.keys(DEFAULT_CATEGORIES) as ConsentCategory[]
}

/**
 * Returns only the categories that are required (cannot be disabled by the user).
 */
export function getRequiredCategories(): ConsentCategory[] {
  return (Object.entries(DEFAULT_CATEGORIES) as [ConsentCategory, CategoryDefinition][])
    .filter(([, def]) => def.required)
    .map(([cat]) => cat)
}

/**
 * Returns only the categories that are optional (user can toggle).
 */
export function getOptionalCategories(): ConsentCategory[] {
  return (Object.entries(DEFAULT_CATEGORIES) as [ConsentCategory, CategoryDefinition][])
    .filter(([, def]) => !def.required)
    .map(([cat]) => cat)
}

/**
 * Checks whether a given string is a valid ConsentCategory.
 */
export function isValidCategory(value: string): value is ConsentCategory {
  return value in DEFAULT_CATEGORIES
}
